import { rest } from 'msw'

export default [
  /**
   * 組織情報
   */
  rest.get('/swc-api/master/organizations', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([
        {
          "code": "0",
          "name": "水ing",
          "customer_type": null,
          "admin": true
        },
        {
          "code": "1",
          "name": "BTI",
          "customer_type": null,
          "admin": false
        },
        {
          "code": "2",
          "name": "C 社",
          "customer_type": null,
          "admin": false
        },
        {
          "code": "3",
          "name": "S 社",
          "customer_type": null,
          "admin": false
        },
        {
          "code": "4",
          "name": "島根県水道局",
          "customer_type": null,
          "admin": false
        },
        {
          "code": "5",
          "name": "TK 大学",
          "customer_type": null,
          "admin": false
        },
        {
          "code": "6",
          "name": "A 社",
          "customer_type": null,
          "admin": false
        },
        {
          "code": "7",
          "name": "P 社",
          "customer_type": null,
          "admin": false
        }
      ]),
    )
  }),
]
